import React from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

import {ContentHotel, Hotel} from '@findhotel/sapi'

const ToastWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`

const IconWrapper = styled.div`
  padding-left: ${cssTheme.layout.spacing.s500};
`

export const PriceWatchToastMessage = ({
  enabled,
  hotel,
  checkIn,
  checkOut,
  shouldShowNavigationIcon
}: {
  hotel: ContentHotel | Hotel
  checkIn: string
  checkOut: string
  enabled: boolean
  shouldShowNavigationIcon?: boolean
}) => {
  const intl = useIntl()

  const values = {
    hotel: (
      <Text tag="span" variant="titleS">
        {hotel?.hotelName}
      </Text>
    ),
    checkIn: (
      <Text tag="span" variant="titleS">
        {intl.formatDate(new Date(checkIn), {
          day: 'numeric',
          month: 'short'
        })}
      </Text>
    ),
    checkOut: (
      <Text tag="span" variant="titleS">
        {intl.formatDate(new Date(checkOut), {
          day: 'numeric',
          month: 'short'
        })}
      </Text>
    )
  }

  const enabledMessage = intl.formatMessage(
    {
      id: 'priceWatchToggle.enabledMessage',
      defaultMessage: 'You’re tracking prices at {hotel} {checkIn} - {checkOut}'
    },
    values
  )

  const disabledMessage = intl.formatMessage(
    {
      id: 'priceWatchToggle.disabledMessage',
      defaultMessage:
        'You’re no longer tracking prices at {hotel} {checkIn} - {checkOut}'
    },
    values
  )

  return enabled ? (
    shouldShowNavigationIcon ? (
      <ToastWrapper>
        <span>{enabledMessage}</span>
        <IconWrapper>
          <Icon size="md" name="ChevronRight" />
        </IconWrapper>
      </ToastWrapper>
    ) : (
      <span>{enabledMessage}</span>
    )
  ) : (
    <span>{disabledMessage}</span>
  )
}

export const PriceWatchToastIcon = ({enabled}: {enabled: boolean}) => (
  <Icon name={enabled ? 'BellRinging' : 'BellOff'} size="md" />
)
